module.exports = __webpack_public_path__ + "img/ring_g_e_1_0.039fb7ef.png";